import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { TableComponent } from '../table.component';
import { TableElement } from '../table.element';
import { TableColumn } from '../table.column';

@Component({
  selector: 'app-table-widget-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.scss']
})
export class NativeStateComponent extends WidgetComponent implements OnInit {
  _nativeState: string;
  @Input() set nativeState(_nativeState: string) {
    this._nativeState = 'status ' + _nativeState;
  }
  get nativeState(): string {
    return this._nativeState;
  }

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }

  public setContent(table: TableComponent, tableElement: TableElement, tableColumn: TableColumn): void {
    super.setContent(table, tableElement, tableColumn);

    const data = tableElement.getData();

    if (typeof data.nativeState === 'undefined') {
      const state = super.getContent();

      if (typeof data._nativeState === 'undefined') {
        this.nativeState = state;
      } else {
        this.nativeState = data._nativeState;
      }
    } else {
      this.nativeState = data.nativeState;
    }
  }

  public getContent() {
    if (typeof this._content === 'undefined') {
      if (this.tableColumn.prefixText) {
        const superContent = super.getContent();
        this._content = this.tableColumn.prefixText + superContent.toLowerCase();
      } else {
        this._content = super.getContent();
      }
    }
    return this._content;
  }
}
